import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./style.scss";

const CSVDetails = ({ recordId, usersList }) => {
  const [csvData, setCSVData] = useState({});

  const showData = () => {
    let newData = usersList?.find((item) => item?._id === recordId);
    setCSVData(newData || {});
  };

  useEffect(() => {
    showData();
  }, []);

  const fileUrl = csvData?.csvAttachment?.[0]?.file?.url;

  const getFileName = (url) => {
    try {
      const decodedUrl = decodeURIComponent(url);
      return decodedUrl.split("/").pop();
    } catch (error) {
      return "Unknown File";
    }
  };

  const fileName = fileUrl ? getFileName(fileUrl) : "N/A";

  const formattedDate = (uploadedDate) => {
    const date = new Date(uploadedDate);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const newDate = date.toLocaleDateString("en-US", options);
    return newDate;
  };

  return (
    <div className="csv_details">
      {fileUrl ? (
        <table>
          <thead>
            <tr>
              <th>CSV File Name</th>
              <th>Uploaded Date</th>
              <th>Original File</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{fileName}</td>
              <td>{formattedDate(csvData?.updatedAt) || "N/A"}</td>
              <td>
                {fileUrl ? (
                  <Link to={fileUrl} target="_blank" rel="noopener noreferrer">
                    Download
                  </Link>
                ) : (
                  "No File Available"
                )}
              </td>
            </tr>
          </tbody>
        </table>
      ) : (
        "No Data Found"
      )}
    </div>
  );
};

export default CSVDetails;
